export enum PriceListTypeEnum {
  Predefined = 'Predefined',
  Custom = 'Custom'
}
